import { z } from 'zod'

export const schema = z.object({
  villages: z.array(
    z.object({
      name: z.string(),
      slug: z.string(),
      description: z.string().nullable(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  slug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
